import { Card, CardContent, CardHeader, Grid, Typography } from "@mui/material";

import { PHONENUMBER_FORMAT } from "../../../../constants";
import { stateApiKeyStore } from "../../../../api/states-api-key-store";
import { FormInput } from "../../../../components/hook-form/form-input.component";
import { FormFormattedInput } from "../../../../components/hook-form/form-formatted-input.component";
import { FormAutoCompleteSelectDynamic } from "../../../../components/hook-form/form-autocomplete-select.dynamic.component";
import { usersApiKeyStore } from "../../../../api/users-api-key-store";

interface EmployeeAddress {
    userID: any;
}
export const EmployeeAddress = ({ userID }: EmployeeAddress) => {
    return (
        <Card elevation={0}>
            <CardHeader
                className="subHead"
                title={
                    <Typography variant="h3" color="textPrimary">
                        ADDRESS
                    </Typography>
                }
            />
            <CardContent className="formContainer">
                <Grid container spacing={2}>
                    <Grid item lg={6} sm={6} xl={6} xs={6}>
                        <FormInput label="Location" name="userAddress" />
                    </Grid>
                    <Grid item lg={3} sm={3} xl={3} xs={3}>
                        <FormAutoCompleteSelectDynamic
                            name="state"
                            label="State"
                            getQueryKeyConfig={() => stateApiKeyStore.getStates()}
                            optionsValueKey="stateID"
                            optionsLabelKey="stateName"
                        />
                    </Grid>
                    <Grid item lg={3} sm={3} xl={3} xs={3}>
                        <FormInput label="City" name="city" />
                    </Grid>
                    <Grid item lg={6} sm={6} xl={6} xs={6}>
                        <FormFormattedInput name="mobile" label="Contact Phone" format={PHONENUMBER_FORMAT} />
                    </Grid>
                    <Grid item lg={6} sm={6} xl={6} xs={6}>
                        <FormInput
                            label="Contact Email"
                            name="email"
                            validationQueryRoute={(value: any) => value && usersApiKeyStore.validateUserEmail(userID, value)}
                        />
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
}